/* ============================================================
   FESTIVE FINDS BY AMRITA — theme behaviour
   All commerce actions go through Shopify's own endpoints:
   /cart/add.js, /cart/change.js, /cart/update.js, /search/suggest
   and the Section Rendering API. Nothing here simulates a cart.
   ============================================================ */
(function () {
  'use strict';

  var T = window.FestiveTheme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    var format = T.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ---------------------------------------------------------
     Overlay / drawer management
     --------------------------------------------------------- */
  var scrim = null;
  var lastFocused = null;

  function getScrim() {
    if (!scrim) scrim = $('[data-scrim]');
    return scrim;
  }

  function openPanel(panel) {
    if (!panel) return;
    lastFocused = document.activeElement;
    panel.classList.add('open');
    panel.removeAttribute('aria-hidden');
    var s = getScrim();
    if (s) s.classList.add('open');
    document.body.classList.add('is-locked');
    var focusable = panel.querySelector('[autofocus], input:not([type=hidden]), button, a[href]');
    if (focusable) window.setTimeout(function () { focusable.focus(); }, 60);
  }

  function closeAllPanels() {
    $$('[data-panel].open').forEach(function (p) {
      p.classList.remove('open');
      p.setAttribute('aria-hidden', 'true');
    });
    var s = getScrim();
    if (s) s.classList.remove('open');
    document.body.classList.remove('is-locked');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      e.preventDefault();
      closeAllPanels();
      openPanel($('[data-panel="' + opener.getAttribute('data-panel-open') + '"]'));
      return;
    }
    if (e.target.closest('[data-panel-close]') || e.target.closest('[data-scrim]')) {
      e.preventDefault();
      closeAllPanels();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* ---------------------------------------------------------
     Mobile submenu + accordions
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.m-toggle');
    if (toggle) {
      var sub = toggle.nextElementSibling;
      if (sub) {
        var open = sub.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var accTrigger = e.target.closest('.acc-trigger');
    if (accTrigger) {
      var item = accTrigger.closest('.acc-item');
      if (item) {
        var isOpen = item.classList.toggle('open');
        accTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }
  });

  /* ---------------------------------------------------------
     Quantity steppers (shared by product form and cart lines)
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;

    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
    var next = (parseInt(input.value, 10) || min) + step;

    if (next < min) next = min;
    if (max !== null && next > max) next = max;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------
     Cart — Shopify Cart AJAX API + Section Rendering API
     --------------------------------------------------------- */
  var CART_SECTIONS = ['cart-drawer'];

  function cartSectionsToRequest() {
    var list = CART_SECTIONS.slice();
    if (document.getElementById('main-cart-section')) list.push('main-cart');
    return list.join(',');
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string') return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var incoming = parsed.querySelector('[data-section-content="' + id + '"]');
      var current = document.querySelector('[data-section-content="' + id + '"]');
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    });
    syncCartCount();
  }

  function syncCartCount() {
    var source = document.querySelector('[data-cart-count-source]');
    if (!source) return;
    var count = parseInt(source.getAttribute('data-cart-count-source'), 10) || 0;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    $$('[data-cart-count-label]').forEach(function (el) {
      el.setAttribute('aria-label', (strings.cartLabel || 'Cart') + ', ' + count);
    });
  }

  function cartRequest(url, body) {
    body.sections = cartSectionsToRequest();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function setDrawerBusy(state) {
    var drawer = $('[data-panel="cart"]');
    if (drawer) drawer.classList.toggle('is-busy', !!state);
  }

  /* Add to cart — product forms and quick-add buttons */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[data-add-button]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.textContent = '';
    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
    }

    var formData = new FormData(form);
    var payload = { items: [] };
    var item = { id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) };
    formData.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) {
        item.properties = item.properties || {};
        item.properties[m[1]] = value;
      }
      if (key === 'selling_plan' && value) item.selling_plan = value;
    });
    payload.items.push(item);

    setDrawerBusy(true);
    cartRequest(routes.cart_add_url || '/cart/add.js', payload)
      .then(function (data) {
        renderCartSections(data.sections);
        closeAllPanels();
        openPanel($('[data-panel="cart"]'));
      })
      .catch(function (err) {
        var message = (err && (err.description || err.message)) || strings.cartError || 'Could not add to cart.';
        if (errorEl) errorEl.textContent = message;
        else window.alert(message);
      })
      .then(function () {
        setDrawerBusy(false);
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
        }
      });
  });

  /* Cart line quantity change + remove */
  function updateLine(key, quantity) {
    setDrawerBusy(true);
    return cartRequest(routes.cart_change_url || '/cart/change.js', { id: key, quantity: quantity })
      .then(function (data) { renderCartSections(data.sections); })
      .catch(function () { window.location.href = routes.cart_url || '/cart'; })
      .then(function () { setDrawerBusy(false); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-quantity]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    updateLine(input.getAttribute('data-line-key'), qty);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    updateLine(remove.getAttribute('data-line-key'), 0);
  });

  /* Cart note — persisted through /cart/update.js */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      fetch(routes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  syncCartCount();

  /* ---------------------------------------------------------
     Predictive search (Shopify /search/suggest)
     --------------------------------------------------------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-input]');
    if (!input) return;
    var results = $('[data-predictive-results]');
    if (!results) return;

    var q = input.value.trim();
    window.clearTimeout(searchTimer);

    if (q.length < 2) {
      results.innerHTML = '';
      return;
    }

    searchTimer = window.setTimeout(function () {
      var url = (routes.predictive_search_url || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=4' +
        '&section_id=predictive-search';

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var incoming = parsed.querySelector('[data-section-content="predictive-search"]');
          results.innerHTML = incoming ? incoming.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 250);
  });

  /* ---------------------------------------------------------
     Collection facets — native facet form, auto-applied
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-facet-toggle]');
    if (toggle) {
      e.preventDefault();
      var facet = toggle.closest('.facet');
      var wasOpen = facet.classList.contains('open');
      $$('.facet.open').forEach(function (f) { f.classList.remove('open'); });
      if (!wasOpen) facet.classList.add('open');
      toggle.setAttribute('aria-expanded', !wasOpen ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('.facet-panel')) {
      $$('.facet.open').forEach(function (f) { f.classList.remove('open'); });
    }
  });

  /* Empty text/number filters would submit as blank query params — drop them so
     the filtered URL stays clean and shareable. Disabled controls are not sent. */
  function stripEmptyFacetInputs(form) {
    Array.prototype.forEach.call(form.elements, function (el) {
      var t = el.type;
      if ((t === 'number' || t === 'text' || t === 'search') && el.value === '') {
        el.disabled = true;
      }
    });
  }

  document.addEventListener('change', function (e) {
    var control = e.target.closest('[data-facet-auto]');
    if (!control) return;
    var form = control.closest('form');
    if (!form) return;
    stripEmptyFacetInputs(form);
    // form.submit() does not fire a submit event, so strip first.
    form.submit();
  });

  document.addEventListener('submit', function (e) {
    var facetForm = e.target.closest('[data-facet-form]');
    if (facetForm) stripEmptyFacetInputs(facetForm);
  });

  /* ---------------------------------------------------------
     Product gallery
     --------------------------------------------------------- */
  function showGallerySlide(gallery, mediaId) {
    var slides = $$('[data-gallery-slide]', gallery);
    var matched = false;
    slides.forEach(function (slide) {
      var isMatch = slide.getAttribute('data-media-id') === String(mediaId);
      slide.classList.toggle('active', isMatch);
      if (isMatch) matched = true;
    });
    if (!matched && slides.length) slides[0].classList.add('active');
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb.getAttribute('data-media-id') === String(mediaId) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    if (gallery) showGallerySlide(gallery, thumb.getAttribute('data-media-id'));
  });

  /* ---------------------------------------------------------
     Variant picker — resolves the real Shopify variant
     --------------------------------------------------------- */
  function initVariantPicker(root) {
    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('form[data-product-form]', root);
    var idInput = form && form.querySelector('[data-variant-id]');
    var gallery = $('[data-gallery]', root);

    function currentOptions() {
      var selected = [];
      $$('[data-option-index]', root).forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var value = null;
        if (group.tagName === 'SELECT') {
          value = group.value;
        } else {
          var checked = group.querySelector('input:checked');
          if (checked) value = checked.value;
        }
        selected[index] = value;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (variant) {
        return selected.every(function (value, i) {
          if (value === null || value === undefined) return true;
          return variant.options[i] === value;
        });
      });
    }

    function setText(selector, value) {
      $$(selector, root).forEach(function (el) { el.innerHTML = value; });
    }

    function update() {
      var selected = currentOptions();
      var variant = findVariant(selected);

      /* Mark option values that produce no purchasable variant */
      $$('[data-option-index]', root).forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        $$('input[type="radio"]', group).forEach(function (input) {
          var probe = selected.slice();
          probe[index] = input.value;
          var match = variants.find(function (v) {
            return probe.every(function (value, i) {
              if (value === null || value === undefined) return true;
              return v.options[i] === value;
            });
          });
          var label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
        var display = group.closest('[data-option-group]');
        var readout = display && display.querySelector('[data-option-value]');
        if (readout && selected[index]) readout.textContent = selected[index];
      });

      var addButton = $('[data-add-button]', root);
      var stickyButton = $('[data-sticky-add]');

      if (!variant) {
        if (idInput) idInput.value = '';
        if (addButton) {
          addButton.setAttribute('disabled', 'disabled');
          addButton.textContent = strings.unavailable || 'Unavailable';
        }
        if (stickyButton) stickyButton.setAttribute('disabled', 'disabled');
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (addButton) {
        if (variant.available) {
          addButton.removeAttribute('disabled');
          addButton.textContent = strings.addToCart || 'Add to Cart';
        } else {
          addButton.setAttribute('disabled', 'disabled');
          addButton.textContent = strings.soldOut || 'Sold Out';
        }
      }
      if (stickyButton) {
        if (variant.available) stickyButton.removeAttribute('disabled');
        else stickyButton.setAttribute('disabled', 'disabled');
      }

      /* Price + compare-at */
      setText('[data-price]', money(variant.price));
      var compareWrap = $('[data-compare-wrap]', root);
      if (compareWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareWrap.removeAttribute('hidden');
          setText('[data-compare-price]', money(variant.compare_at_price));
          setText('[data-save-amount]', money(variant.compare_at_price - variant.price));
          $$('[data-price]', root).forEach(function (el) { el.classList.add('on-sale'); });
        } else {
          compareWrap.setAttribute('hidden', '');
          $$('[data-price]', root).forEach(function (el) { el.classList.remove('on-sale'); });
        }
      }

      /* Availability */
      var stock = $('[data-stock-row]', root);
      if (stock) {
        stock.classList.remove('stock-row--low', 'stock-row--out');
        var label = stock.querySelector('[data-stock-label]');
        if (!variant.available) {
          stock.classList.add('stock-row--out');
          if (label) label.textContent = strings.soldOut || 'Sold out';
        } else if (variant.inventory_management && variant.inventory_policy === 'deny' &&
                   typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0) {
          if (variant.inventory_quantity <= (T.lowStockThreshold || 5)) {
            stock.classList.add('stock-row--low');
          }
          if (label) label.textContent = (strings.inventoryAvailable || 'COUNT available').replace('COUNT', variant.inventory_quantity);
        } else if (label) {
          label.textContent = strings.inStock || 'In stock — ready to ship';
        }
      }

      /* Keep the quantity selector within tracked inventory */
      var quantityInput = $('[data-product-quantity]', root);
      if (quantityInput) {
        if (variant.inventory_management && variant.inventory_policy === 'deny' &&
            typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0) {
          quantityInput.setAttribute('max', variant.inventory_quantity);
          if ((parseInt(quantityInput.value, 10) || 1) > variant.inventory_quantity) {
            quantityInput.value = variant.inventory_quantity;
          }
        } else {
          quantityInput.removeAttribute('max');
        }
      }

      /* SKU */
      var sku = $('[data-sku]', root);
      if (sku) sku.textContent = variant.sku || '';

      /* Gallery follows the variant image */
      if (gallery && variant.featured_media) showGallerySlide(gallery, variant.featured_media.id);

      /* Sticky bar summary */
      var stickyTitle = $('[data-sticky-variant]');
      if (stickyTitle) stickyTitle.textContent = variant.title;
      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(variant.price);

      /* Keep the URL shareable without a reload */
      if (variant.id && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });

    update();
  }

  $$('[data-product-root]').forEach(initVariantPicker);

  /* Sticky mobile add-to-cart proxies the real form */
  document.addEventListener('click', function (e) {
    var sticky = e.target.closest('[data-sticky-add]');
    if (!sticky) return;
    e.preventDefault();
    var form = $('form[data-product-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  /* ---------------------------------------------------------
     Share — copy link
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-copy-link]');
    if (!copy) return;
    e.preventDefault();
    var url = copy.getAttribute('data-copy-link') || window.location.href;
    var done = function () {
      var original = copy.textContent;
      copy.textContent = strings.copied || 'Copied';
      window.setTimeout(function () { copy.textContent = original; }, 1600);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {});
    else done();
  });

  /* ---------------------------------------------------------
     Product recommendations (Shopify Product Recommendations API)
     --------------------------------------------------------- */
  function swapRemoteSection(host, url, contentSelector) {
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var incoming = parsed.querySelector(contentSelector);
        var current = host.querySelector(contentSelector);
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      })
      .catch(function () {});
  }

  $$('[data-product-recommendations]').forEach(function (host) {
    var url = host.getAttribute('data-url');
    if (url) swapRemoteSection(host, url, '[data-recs-content]');
  });

  /* ---------------------------------------------------------
     Recently viewed — stored locally, resolved via Shopify search
     --------------------------------------------------------- */
  var RECENT_KEY = 'festive:recently-viewed';

  function readRecent() {
    try { return JSON.parse(window.localStorage.getItem(RECENT_KEY)) || []; }
    catch (err) { return []; }
  }

  function rememberProduct(id) {
    if (!id) return;
    var list = readRecent().filter(function (existing) { return existing !== id; });
    list.unshift(id);
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12))); }
    catch (err) {}
  }

  $$('[data-recently-viewed]').forEach(function (host) {
    var currentId = host.getAttribute('data-current-product');
    var limit = parseInt(host.getAttribute('data-limit'), 10) || 4;
    var ids = readRecent().filter(function (id) { return id !== currentId; }).slice(0, limit);

    if (currentId) rememberProduct(currentId);
    if (!ids.length) return;

    var query = ids
      .map(function (id) { return 'id:' + id; })
      .join(' OR ');

    swapRemoteSection(
      host,
      host.getAttribute('data-url') + '&q=' + encodeURIComponent(query),
      '[data-recently-viewed-content]'
    );
  });

  /* ---------------------------------------------------------
     Header height → sticky offsets stay correct on all devices
     --------------------------------------------------------- */
  function setHeaderHeight() {
    var header = $('.header');
    if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  /* Re-init after Theme Editor section reloads */
  document.addEventListener('shopify:section:load', function (e) {
    scrim = null;
    syncCartCount();
    setHeaderHeight();
    $$('[data-product-root]', e.target).forEach(initVariantPicker);
  });
})();
